import { TabStrip } from "../core/components/tabStrip.js";
import React from "react";

export default class ContactPersons extends React.Component<any, any>{
    private _metaData = {
        tabs: [
            {
                title: "project",
                moduleName: "app/project/projectContacts"
            },
            {
                title: "address",
                moduleName: "app/project/addressContacts"
            }
        ],
        additional: {
            objects: []
        }
    };

    constructor(props) {
        super(props)
        this._metaData.tabs[0].title = this.props.translations["Projekt.ProjectContactPersons"];
        this._metaData.tabs[1].title = this.props.translations["Projekt.AddressContactPersons"];
    }

    render() {
        return (
            <div className="flex-container__item flex-container">
                <TabStrip metadata={this._metaData} entity={this.props.entity} dataSources={{}} horizontal={true}
                    context={this.props.context} onChange={null} onDataLoaded={this.props.onDataLoaded}
                    handleEval={this.props.handleEval} handleIsSearchFieldFullObjectModel={this.props.handleIsSearchFieldFullObjectModel}
                    handleIndividulFieldsMetaDataCreated={this.props.handleIndividulFieldsMetaDataCreated}
                    commandManager={this.props.commandManager} translations={this.props.translations} />
            </div>
        );
    }
}